import type { LangCode } from "@/api/types";

import { EditableSection } from "./EditableSection";
import { Field } from "./Field";
import { RegulatoryCaseBlock } from "./RegulatoryCaseBlock";
import { collectRuHints, type RecordTabFormProps } from "./shared";

const TRIGGER_TOOLTIP =
  "Триггер — фраза-лемма, которой matcher находит эту область в EN-тексте " +
  "регуляторного документа (SmPC). Грамматически НЕ обязан совпадать с " +
  "RU-переводом справа: задача триггера — обозначить область, а не быть " +
  "переводимым.";
const TRANSLATION_TOOLTIP =
  "Перевод используется как ориентир для переводчика-LLM в этой регуляторной " +
  "теме. В реальном тексте грамматическая адаптация и склонения делаются " +
  "переводчиком; автозамены в строке не происходит (constraint_eligible=false).";

/** Форма для item_type=enforcement_candidate.
 *  Триггер EN + RU canonical перевод концепта + readonly блок regulatory case. */
export function EnforcementCandidateForm({
  item,
  payload,
  editMode,
  draft,
  onChange,
  onCancelEdit,
}: RecordTabFormProps) {
  const srcLang = (item.source_lang ?? null) as LangCode | null;
  const tgtLang = (item.target_lang ?? null) as LangCode | null;

  const ruHints = collectRuHints(payload.ru_term_hints);
  const preferredHint =
    ruHints.find((h) => h.hintType === "preferred") ?? ruHints[0];

  const triggerValue =
    editMode && draft.source_text != null
      ? draft.source_text
      : (payload.source_text ?? item.source_text ?? "");
  const ruTermValue =
    editMode && draft.ru_term != null
      ? draft.ru_term
      : (payload.ru_term ??
        item.candidate_text ??
        preferredHint?.text ??
        "");

  return (
    <>
      <EditableSection
        title="EN-фраза и её перевод"
        editMode={editMode}
        draftCount={Object.keys(draft).length}
        onCancelEdit={onCancelEdit}
      >
        <div className="rf-form-grid">
          <Field
            fieldKey="source_text"
            label="Оригинал"
            langTag={srcLang}
            value={triggerValue}
            editable={editMode}
            helpTooltip={TRIGGER_TOOLTIP}
            onChange={onChange}
          />
          <Field
            fieldKey="ru_term"
            label="Перевод"
            langTag={tgtLang}
            value={ruTermValue}
            editable={editMode}
            keepEmpty
            helpTooltip={TRANSLATION_TOOLTIP}
            onChange={onChange}
          />
        </div>
      </EditableSection>

      {ruHints.length > 0 && (
        <RegulatoryCaseBlock hints={ruHints} payload={payload} />
      )}
    </>
  );
}
